import { API_BASE_URL } from '@/utils/env';
import { getToken } from '@/utils/auth';

/**
 * Record an admin action in the server-side audit log. Best-effort and
 * non-blocking — a logging failure must never break the action that triggered it.
 *
 * Note: admin-on-behalf edits to a user record (payment / unlock / activation /
 * notes / order status) are logged automatically by the backend `PUT /auth/user/:uid`
 * handler, so those do NOT need an explicit call. Use this for client-only actions
 * such as pricing / config changes.
 */
export function logAdminAction(
  action: string,
  target?: string | null,
  details?: Record<string, unknown> | null,
): void {
  try {
    const token = getToken();
    fetch(`${API_BASE_URL}/auth/admin/audit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ action, target: target ?? null, details: details ?? null }),
    }).catch(() => {});
  } catch {
    /* never throw from audit logging */
  }
}
